import { BaseStorageAdapter } from './base';

const SEPARATOR = ':';

export class LocalStorageAdapter implements BaseStorageAdapter {
  id: string;

  constructor(id: string) {
    this.id = id;
  }

  get storage() {
    return window.localStorage;
  }

  normalizeKey(key: string) {
    return key.split(SEPARATOR)[1];
  }

  serializeKey(key: string) {
    return `${this.id}${SEPARATOR}${key}`;
  }

  normalizeValue(value: string) {
    return JSON.parse(value);
  }

  serializeValue(value: any) {
    return JSON.stringify(value);
  }

  getItem<T>(key: string) {
    const serializedKey = this.serializeKey(key);
    const serializedValue = this.storage.getItem(serializedKey);

    return serializedValue ? (this.normalizeValue(serializedValue) as T) : null;
  }

  setItem<T>(key: string, value: T) {
    const serializedKey = this.serializeKey(key);
    const serializedValue = this.serializeValue(value);

    this.storage.setItem(serializedKey, serializedValue);
  }

  getRawItem(key: string) {
    const serializedKey = this.serializeKey(key);
    const serializedValue = this.storage.getItem(serializedKey);

    return serializedValue || '';
  }
}
